module.exports = __webpack_public_path__ + "static/media/icon_nav_account.f99d0622.svg";